import { Box, Paper, Typography } from '@mui/material';
import { useRecoilValue } from 'recoil';
import { Order } from '../../interfaces/Order/Order';
import { sharedStyles } from '../../utils/Style';
import { Barcode } from '../../components/Barcode/Barcode';
import { OrderProductsTable } from '../Order/OrderDetails/OrderProductsTable';
import { shippingProvidersAtom } from '../../atoms/ShippingProvider';
import { isBase64Image } from '../../utils/Image';

interface PrintShipmentPaperProps {
  storeName: string;
  barcodeImage?: string;
  order: Order;
  breakPage?: boolean;
}

export const PrintShipmentPaper = ({
  storeName,
  barcodeImage,
  order,
  breakPage,
}: PrintShipmentPaperProps) => {
  const shippingProviders = useRecoilValue(shippingProvidersAtom);

  const isValidBarcode = !!barcodeImage && isBase64Image(barcodeImage);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: 800,
        alignItems: 'center',
        p: 3,
        pageBreakAfter: breakPage ? 'always' : undefined,
      }}
    >
      {storeName && (
        <Typography sx={{ ...sharedStyles.h3, fontWeight: 'bold', mb: 5 }}>
          {storeName}
        </Typography>
      )}
      {isValidBarcode && (
        <Box component='img' src={barcodeImage} height='auto' width='70%' />
      )}

      {!isValidBarcode && !!order && (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 3,
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              width: '85%',
              gap: 1.5,
              justifyContent: 'center',
            }}
          >
            <Paper
              sx={{
                display: 'flex',
                flexDirection: 'column',
                flex: '1 1 0',
                p: 3,
              }}
            >
              <Typography
                sx={{ ...sharedStyles.h5, fontWeight: 'bold', mb: 1.5 }}
              >
                Alıcı Bilgileri
              </Typography>
              <Typography>
                {`Ad Soyad: ${order.shippingFirstName} ${order.shippingLastName}`}
              </Typography>
              <Typography>{`Telefon: ${order.customerPhone}`}</Typography>
              <Typography>Adres:</Typography>
              <Typography>{order.shippingAddress1}</Typography>
              {!!order.shippingAddress2 && (
                <Typography>{order.shippingAddress2}</Typography>
              )}
              <Typography>
                {`${order.shippingCity}, ${order.shippingState} ${
                  order.shippingZip ?? ''
                }`}
              </Typography>
            </Paper>
            <Paper
              sx={{
                display: 'flex',
                flexDirection: 'column',
                flex: '1 1 0',
                p: 3,
              }}
            >
              {!!order.cargoKey && (
                <>
                  <Typography
                    sx={{ ...sharedStyles.h5, fontWeight: 'bold', mb: 1.5 }}
                  >
                    Barkod
                  </Typography>
                  <Barcode value={order.cargoKey} />
                </>
              )}

              {(!!order.cargoNo || !!barcodeImage) && (
                <>
                  <Typography
                    sx={{ ...sharedStyles.h5, fontWeight: 'bold', mb: 1.5 }}
                  >
                    Entegrasyon Kod
                  </Typography>
                  <Barcode value={barcodeImage ?? order.cargoNo!} />
                </>
              )}

              <Typography>
                {`Kargo Firması: ${
                  shippingProviders.find(
                    (s) => s.id.toString() === order.shippingMethod,
                  )?.name
                }`}
              </Typography>
              <Typography>{`Kargo No: ${
                order.cargoNo ?? barcodeImage ?? ''
              }`}</Typography>
            </Paper>
          </Box>

          <Box
            sx={{
              width: '85%',
            }}
          >
            <OrderProductsTable orderProducts={order.products} />
          </Box>
        </Box>
      )}
    </Box>
  );
};
